import api, { BASE_URL } from "../../api";

const MERCHANT_BASE_URL = `${BASE_URL}/shop/admin/merchants/`;

const listMerchants = context => {
  return api(context)
    .get(MERCHANT_BASE_URL)
    .then(response => response.data);
};

const getMerchant = (context, key) => {
  return api(context)
    .get(`${MERCHANT_BASE_URL}${key}/`)
    .then(response => response.data);
};

const updateMerchant = (context, merchant) => {
  return api(context)
    .patch(`${MERCHANT_BASE_URL}${merchant.id}/`, merchant)
    .then(response => response.data);
};

const insertMerchant = (context, merchant) => {
  return api(context)
    .post(MERCHANT_BASE_URL, merchant)
    .then(response => response.data);
};

const deleteMerchant = (context, merchantID) => {
  return api(context)
    .delete(`${MERCHANT_BASE_URL}${merchantID}/`)
    .then(response => response.data);
};

const getMerchantLocations = (context, key) => {
  return api(context)
    .get(`${MERCHANT_BASE_URL}${key}/pickup-locations/`)
    .then(response => response.data);
};

const updateMerchantLocation = (context, merchant) => {
  return api(context)
    .patch(`${MERCHANT_BASE_URL}${merchant.id}/pickup-locations/`, merchant)
    .then(response => response.data);
};

const insertMerchantLocation = (context, location) => {
  return api(context)
    .post(
      `${MERCHANT_BASE_URL}${location.merchantID}/pickup-locations/`,
      location.location
    )
    .then(response => response.data);
};

const deleteMerchantLocation = (context, merchantID) => {
  return api(context)
    .delete(`${MERCHANT_BASE_URL}${merchantID}/`)
    .then(response => response.data);
};

const merchant = {
  BASE_URL: MERCHANT_BASE_URL,
  list: listMerchants,
  get: getMerchant,
  update: updateMerchant,
  insert: insertMerchant,
  delete: deleteMerchant,
  locations: {
    get: getMerchantLocations,
    insert: insertMerchantLocation
  }
};

export default merchant;
